import { useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import {
  imageCodes,
  textCodes,
  titleCodes,
  videoCodes,
} from "../../template_codes/madnest/about_page_codes";

function About() {
  const [showTab, setShowTab] = useState(false);
  return (
    <React.Fragment>
      <div className="font-quicksand" data-theme="weireframe">
        <div class="navbar ">
          <div class="navbar-start"></div>
          <div class="navbar-center lg:flex">
            <ul class="menu menu-horizontal p-0">
              <li className="p-2">
                <Link to={paths.home}>Home</Link>
              </li>
              <li>
                <a href="https://themadnest.com">Shop</a>
              </li>
              <li className="p-2">
                <Link to={paths.about}>About Us</Link>
              </li>
              <li className="p-2">
                <Link to={paths.contact}>Contact</Link>
              </li>
            </ul>
          </div>
          <div className="navbar-end"></div>
        </div>

        {/*                        love note section                        */}
        <div className=" hero w-full h-52 pb-10 lg:h-1/3 xl:h-1/3">
          <img
            src={imageCodes.background.image}
            className="py-1 w-full h-48 md:h-full lg:h-full xl:h-full"
          />
          <div className="w-fix pt-10">
            <div className="pt-10 lg:pt-10 xl:pt-10">
              <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-[#f2c41e] text-center pb-10">
                {titleCodes.aboutTitle.title}
              </h1>
            </div>
            <div className="container w-4/5">
              <p className="text-md leading-loose text-justify lg:text-xl xl:text-xl font-bold text-[#f2c41e] pb-10">
                {textCodes.aboutmd.text}
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-5 xl:grid-cols-5 pt-20 pb-20 lg:px-20 xl:px-20 px-4">
              <div className="lg:pr-2 xl:pr-2 pb-2 focus-visible">
                <img src={imageCodes.about4.image}></img>
              </div>
              <div className="lg:pl-2 xl:pl-2 pb-2">
                <img src={imageCodes.about.image}></img>
              </div>
              <div className="lg:pl-2 xl:pl-2 pb-2">
                <img src={imageCodes.about1.image}></img>
              </div>
              <div className="lg:pl-2 xl:pl-2 pb-2">
                <img src={imageCodes.about2.image}></img>
              </div>
              <div className="lg:pl-2 xl:pl-2 pb-2">
                <img src={imageCodes.about3.image}></img>
              </div>
            </div>
          </div>
        </div>

        {/*                        end of love note section                */}
      </div>
    </React.Fragment>
  );
}

export default About;
